export default "__VITE_ASSET__DXKqjXLq__"